/**
 * Вычисление координат для трансформации канваса (эмуляция работы нативного Transform) с масштабом
 */
export function calculateEmulateTransform(dataX, dataY, a, b, c, d, scale) {
    //(izo x = x*a + c*y; точка середины izo картинки)
    //(izo y = y*d + b*x)
    return {
        x: (a * dataX + c * dataY),// * scale, //масштаб в самом конце применяется
        y: (d * dataY + b * dataX)// * scale
    }
}

/**
 * Переворот координаты Y относительно заданного "нуля"
 */
export function flipYTransform(izoY, baseZero) {
    return baseZero - izoY;
}

/**
 * Вычисление координат эмуляции Transform с переворотом по Y
 */
export function calculateEmulateTransformWithFlip(dataX, dataY, a, b, c, d, baseZero, scale) {
    let izoXY = calculateEmulateTransform(dataX, dataY, a, b, c, d, scale);
    izoXY.y = flipYTransform(izoXY.y, baseZero);
    return izoXY;
}

/**
 * Вычисление координат эмуляции Transform с поворотом на 90
 */
export function calculateEmulateTransformWithFlipAndRotate(baseX, baseY, dataX, dataY, a, b, c, d, baseZero, scale) {
//тестимся ...
//let izoXY = calculateEmulateTransformWithFlip(dataY, dataX, a, b, c, d, baseZero, scale);
let izoXY = calculateEmulateTransform(dataY, dataX, a, b, c, d, scale);
//izoXY.y = flipYTransform(izoXY.y, baseZero);


// console.log('baseZero', baseZero);
// console.log('baseXY', baseX, baseY);
// console.log('dataXY', dataX, dataY);
// console.log('izoXY', izoXY.x, izoXY.y);

    return {
        x: baseX + izoXY.x,
        y: baseY + izoXY.y
    };
}

/**
 * Вычисление координат обратной трансформация - простое преобразование из изометрических координат в базовые (без переворота и ротации)
 */
export function calculateBackTransform(izoX, izoY, a, b, c, d, scale) {
    //вариант вычисления через y
    // let resultY = (a * izoY - b * izoX) / (a * d + b * c);
    // let resultX = (izoX - c * resultY) / a;

    //вариант вычисления через x
    let resultX = 0;

    if (a * d - b * c !== 0) {
        resultX = (d * izoX - c * izoY) / (a * d - b * c);
    }

    let resultY = 0;

    if (d !== 0) {
        resultY = (izoY - b * resultX) / d;
    }

    return {
        x: resultX, //тут относительные величины, scale не участвует
        y: resultY
    }
}

/**
 * Вычисление координат обратной трансформации с учетом переворота Y
 */
export function calculateBackTransformWithFlip(izoX, izoY, a, b, c, d, baseZero, scale) {
    izoY = flipYTransform(izoY, baseZero);
    return calculateBackTransform(izoX, izoY, a, b, c, d, scale);
}

/**
 * Вычисление координат оборудования при мышеперетаскивании в режиме "вид сверху"
 */
export function calculateTopViewXYMovement(x, y, selectedEquipment, baseXY, scale, a, b, c, d) {
    let oldPositionIzoXY = selectedEquipment.oldIzoPosition;
    //let oldPositionInImageXY = selectedEquipment.oldPosition;
    let dx = 0;
    let dy = 0;
    //I. Варианты через коррекцию (8.5 х 3.9)
    // *******************
    //1)Нет изометрии
    // dx = x / scale - oldPositionInImageXY.x;
    // dy = y / scale - oldPositionInImageXY.y;
    // **********************
    // 2) + с пипсами - не рабочий,
    //дрожат, колебания нарастают и оборудование улетает к ебеням
    //    dx = x / scale - oldPositionInImageXY.x;
    //    dy = y / scale - oldPositionInImageXY.y;

    // // let countTwipX = (x - oldPositionIzoXY.x) / scale - oldPositionInImageXY.x;
    // // let countTwipY = (y - oldPositionIzoXY.y) / scale - oldPositionInImageXY.y;
    // // dx = dx + countTwipY * 85 / 100;
    // // dy = dy - countTwipX * 39 / 100;
    // ***************************

    // //3)  скачок, ускорение и не учитывается клик внутри оборудования
    //  dx = x + y * 85 / 100;
    //  dy = y - x * 39 / 100;

    // **********************
    // // 4) Вариант с простой подменой (8.5 х 3.9). Без скачка, но не учитывается искажение.
    // dx = x / scale - oldPositionInImageXY.x;
    // dy = y / scale - oldPositionInImageXY.y;

    // dx += y * 85 / 100;
    // dy -= x * 39 / 100;
    // ***************************

    // //5)  скачок, маленькое ускорение, плохая изометрия, не учитывается клик внутри оборудования
    // dx = x / scale - oldPositionInImageXY.x;
    // dy = y / scale - oldPositionInImageXY.y;
    // dx = x + dy * 85 / 100;
    // dy = y - dx * 39 / 100;
    // **********************

// console.log('*************************');
// console.log('xy', x,y);
// console.log('baseXY', baseXY);

// console.log('oldPositionIzoXY', oldPositionIzoXY);
// console.log('oldPositionInImageXY', oldPositionInImageXY);

    // II. Варианты через формулы
//     // **********************
//     // 6) Дергается, скачок и плохая изометрия
//       //координаты topView
//       let oldPositionTopViewXY = calculateBackTransform(oldPositionIzoXY.x, oldPositionIzoXY.y, a, b, c, d, scale);

//       // после backTransform меняем местами x и y:
//       let oldTopViewX = oldPositionTopViewXY.y;
//       let oldTopViewY = oldPositionTopViewXY.x;

//       console.log('oldPositionTopViewXY', oldTopViewX, oldTopViewY);

//       //Получим линейную разницу между IZO и topView точками
//       let LineDiffx = oldTopViewX - oldPositionIzoXY.x;
//       let LineDiffy = oldTopViewY - oldPositionIzoXY.y;

//       console.log('LineDiff',LineDiffx, LineDiffy);

//       //Координаты точки клика (старой позиции) "внутри" topView оборудования
//       let lineDClickX = LineDiffx - oldPositionInImageXY.x;
//       let lineDClickY = LineDiffy - oldPositionInImageXY.y;

//       console.log('lineDClick', lineDClickX, lineDClickY);

//       //Новые координаты topView оборудования:
//       let lineX = x - lineDClickX;
//       let lineY = y - lineDClickY;

//       console.log('lineXY', lineX,lineY);

//       //И ищем IZO координаты для lineX и lineY. Где должно быть оборудование, чтобы после преобразования
//       //оно оказалось в текущей точке x,y:
//       let izoXY = calculateEmulateTransform(lineX, lineY, a, b, c, d, scale);

//  console.log('izoXY', izoXY)
//           dx = izoXY.x;
//           dy = izoXY.y;

    // **********************
    // 7) Рабочий вариант. Простая эмуляция (координаты поменяны местами).
    // Косяк со скачком, точкой клика внутри оборудования, масштабом и движением площадки
    //   let izoXY = calculateEmulateTransform(y / scale, x / scale, a, b, c, d, scale);
    //   dx = izoXY.x;
    //   dy = izoXY.y;
    // **********************
    // // 8) Вариант 7, координаты поменяны до преобразования. Вообще не рабочий.
    //   let izoXY = calculateEmulateTransform(x / scale, y / scale, a, b, c, d, scale);
    //   dx = izoXY.y;
    //   dy = izoXY.x;

 // **********************
    //  // 9) Рабочий вариант 7 + рабочий клик внутри изделия, (остались косяк со скачком, масштабом, движением площадки)
    //  dx = x / scale - oldPositionInImageXY.x;
    //  dy = y / scale - oldPositionInImageXY.y;
    //  let izoXY = calculateEmulateTransform(dy, dx, a, b, c, d, scale);
    //  dx = izoXY.x;
    //  dy = izoXY.y;

     // **********************
    // 10) Рабочий На вариант 9 (Вычитание координат бызы до эмуляции и прибавление после).
    // (хорошее изо, клик внутри оборудования и движение площадки)
    // (косяки со скачком и масштабом)
    //  dx = x / scale - oldPositionInImageXY.x - baseXY.x;
    //  dy = y / scale - oldPositionInImageXY.y - baseXY.y;
    //  let izoXY = calculateEmulateTransform(dy, dx, a, b, c, d, scale);
    //  dx = izoXY.x + baseXY.x;
    //  dy = izoXY.y + baseXY.y;

     // **********************
    //  // // 11) Рабочий вариант 10 Хорошо все кроме скачка
    //  dx = x / scale - oldPositionInImageXY.x - baseXY.x / scale;
    //  dy = y / scale - oldPositionInImageXY.y - baseXY.y / scale;
    //  let izoXY = calculateEmulateTransform(dy, dx, a, b, c, d, scale);
    //  dx = izoXY.x + baseXY.x / scale;
    //  dy = izoXY.y + baseXY.y / scale;


      // **********************
      // 12) На варианте 11 Переворот по "y" - не рабочий
    // dx = (x - baseXY.x) / scale - oldPositionInImageXY.x;
    // dy = (y - baseXY.y) / scale - oldPositionInImageXY.y;
    // let izoXY = calculateEmulateTransformWithFlip(dy, dx, a, b, c, d, baseXY.y, scale);
    // dx = izoXY.x + baseXY.x / scale;
    // dy = izoXY.y + baseXY.y / scale;

    // **********************
    // 13) Вариант 11 Шаблон для вычислений, выяснили, что надо не эмулировать!
    // //Координаты изо точки до преобразований (не трогаем):
    // dx = (x - baseXY.x) / scale - oldPositionInImageXY.x;
    // dy = (y - baseXY.y) / scale - oldPositionInImageXY.y;

    // //меняемая часть:
    // console.log('dxy', dx, dy);
    // //....что-то сделать...
    // let izoXY = {x: dx, y:dy};

    // //эту часть тоже не трогаем:
    // dx = izoXY.x + baseXY.x / scale;
    // dy = izoXY.y + baseXY.y / scale;

    // **********************
//     //14) Вариант 2 пипсы с коррекцией дрожания. Не успех. т.к. x,y, с каждым сдвигом перезаписываются.
//     //Координаты изо точки до преобразований (не трогаем):
//     dx = (x - baseXY.x) / scale - oldPositionInImageXY.x;
//     dy = (y - baseXY.y) / scale - oldPositionInImageXY.y;

//     //меняемая часть:
//     let countTwipX = (x - oldPositionIzoXY.x) / scale - oldPositionInImageXY.x;
//     let countTwipY = (y - oldPositionIzoXY.y) / scale - oldPositionInImageXY.y;
// //    console.log('countTwipXY', countTwipX, countTwipY);
//     //вернем dx, dy где были, а затем сдвинем на изо величины:
//     dx -= countTwipX;
//     dy -= countTwipY;
//   //  console.log('dxy1', dx, dy);

//     let izoXY = calculateEmulateTransform(countTwipY, countTwipX, a, b, c, d, scale);

//     //эту часть тоже не трогаем:
//     dx += izoXY.x + baseXY.x / scale;
//     dy += izoXY.y + baseXY.y / scale;
//    //console.log('dxy2', dx, dy);

    // **********************
    // // 16) Рабочий вариант 11 без скачка, но с косяком в клике внутри оборудования
    //  dx = x / scale - baseXY.x / scale;
    //  dy = y / scale - baseXY.y / scale;
    //  let izoXY = calculateEmulateTransform(dy, dx, a, b, c, d, scale);
    //  dx = izoXY.x + baseXY.x / scale;
    //  dy = izoXY.y + baseXY.y / scale;
     // **********************

     // // 17) Вариант 16 неудачная попытка фикисровать сдвиг после трансформации
    //  dx = x / scale - baseXY.x / scale;
    //  dy = y / scale - baseXY.y / scale;
    //  let izoXY = calculateEmulateTransform(dy, dx, a, b, c, d, scale);
    //  dx = izoXY.x + baseXY.x / scale;
    //  dy = izoXY.y + baseXY.y / scale;

    //  let oldPositionTopViewXY = calculateBackTransform((oldPositionIzoXY.x - baseXY.x) / scale, (oldPositionIzoXY.y - baseXY.y) / scale, a, b, c, d, scale);
    //  //помним что x и y местами поменять надо
    //  console.log('oldPositionTopViewXY', oldPositionTopViewXY);
    // let dx1 = selectedEquipment.clickCoordinates.x / scale - oldPositionTopViewXY.y / scale;
    // let dy1 = selectedEquipment.clickCoordinates.y / scale - oldPositionTopViewXY.x / scale;
    // console.log('dxy1', dx1, dy1);
    // dx -= dx1;
    // dy -= dy1;

     // // 17) Рабочий вариант 16 с фиксацией позиции клика внутри оборудования до трансформации
     //косяк в масштабе и сдвиге площадки
//     let oldPositionTopViewXY = calculateBackTransform((oldPositionIzoXY.x - baseXY.x) / scale, (oldPositionIzoXY.y - baseXY.y) / scale, a, b, c, d, scale);
//     //помним что x и y местами поменять надо
//     console.log('oldPositionTopViewXY', oldPositionTopViewXY);
// //     console.log('selectedEquipment', selectedEquipment);

//      let dx1 = selectedEquipment.clickCoordinates.x / scale - oldPositionTopViewXY.y / scale;
//      let dy1 = selectedEquipment.clickCoordinates.y / scale - oldPositionTopViewXY.x / scale;
// console.log('dxy1', dx1, dy1);

//      dx = x / scale - baseXY.x / scale - dx1;
//      dy = y / scale - baseXY.y / scale - dy1;
//      let izoXY = calculateEmulateTransform(dy, dx, a, b, c, d, scale);
//      dx = izoXY.x + baseXY.x / scale;
//      dy = izoXY.y + baseXY.y / scale;

    // // 18) Рабочий вариант 17 (остался косяк в масштабе)
//     let oldPositionTopViewXY = calculateBackTransform((oldPositionIzoXY.x - baseXY.x) / scale, (oldPositionIzoXY.y - baseXY.y) / scale, a, b, c, d, scale);
//     //помним что x и y местами поменять надо
//     console.log('oldPositionTopViewXY', oldPositionTopViewXY);
// //     console.log('selectedEquipment', selectedEquipment);

//      let dx1 = selectedEquipment.clickCoordinates.x / scale - oldPositionTopViewXY.y / scale;
//      let dy1 = selectedEquipment.clickCoordinates.y / scale - oldPositionTopViewXY.x / scale;
// console.log('dxy1', dx1, dy1);

//      dx = x / scale - dx1;
//      dy = y / scale - dy1;
//      let izoXY = calculateEmulateTransform(dy, dx, a, b, c, d, scale);
//      dx = izoXY.x + baseXY.x / scale;
//      dy = izoXY.y + baseXY.y / scale;

// // 19) Рабочий вариант 18
    let oldPositionTopViewXY = calculateBackTransform(oldPositionIzoXY.x - baseXY.x / scale, oldPositionIzoXY.y - baseXY.y / scale, a, b, c, d, scale);
     let dx1 = selectedEquipment.clickCoordinates.x / scale - oldPositionTopViewXY.y;
     let dy1 = selectedEquipment.clickCoordinates.y / scale - oldPositionTopViewXY.x;
     dx = x / scale - dx1;
     dy = y / scale - dy1;
     let izoXY = calculateEmulateTransform(dy, dx, a, b, c, d, scale);
     dx = izoXY.x + baseXY.x / scale;
     dy = izoXY.y + baseXY.y / scale;
    // **********
//    console.log('izoXY', izoXY);
  return {
    x: dx,
    y: dy
  }
}


const arrayMoveMutate = (array, from, to) => {
  const startIndex = from < 0 ? array.length + from : from;

  if (startIndex >= 0 && startIndex < array.length) {
    const endIndex = to < 0 ? array.length + to : to;

    const [item] = array.splice(from, 1);
    array.splice(endIndex, 0, item);
  }
};

export const arrayMove = (array, from, to) => {
  array = [...array];
  arrayMoveMutate(array, from, to);
  return array;
};
